import React from "react";

import FormModal from "../../ui/modal/Modal";
import Button from "../button/button";
import EquisClose from "../icons/EquisClose";

import "./ModalDecision.scss";
import useLockScroll from "../../../hooks/useBlockScroll";

interface ModalDecisionProps {
    isOpen: boolean;
    title: string;
    confirmLink?: string;
    confirmText?: string;
    cancelText?: string;
    onCloseModal?: () => void;
    onConfirm?: () => void;
    onCancel?: () => void;
}

const ModalDecision = ({
    isOpen,
    title,
    confirmLink,
    confirmText = "Si quiero",
    cancelText = "No, quiero regresar",
    onCloseModal,
    onCancel,
    onConfirm,
}: ModalDecisionProps) => {

   // Bloquea el scroll
   useLockScroll(isOpen);

    const handleCloseModal = () => {
        onCloseModal?.();
    };


    if (!isOpen) {
        return null;
    }

    return (
        <FormModal
            showModal={isOpen}
            onClose={handleCloseModal}
            className="a-modal-decision"
        >
            <div>
                <div className="a-modal-decision__close" role="button">
                    <EquisClose role="button" onClick={handleCloseModal} />
                </div>

                <div className="a-modal-decision__body">
                    <h5 className="a-modal-decision__title">{title}</h5>
                    <div className="a-modal-decision__footer">
                        <Button
                            type={ confirmLink ? "link" :"button"}
                            href={confirmLink}
                            self={!!confirmLink}
                            classname={`a-button__magenta-modal-aceleradora  big center`}
                            text={confirmText}
                            isDisabled={false}
                            onClickAction={onConfirm}
                        ></Button>
                        <Button
                            type={"button"}
                            classname={`a-button__magenta_aceleradora big center`}
                            text={cancelText}
                            isDisabled={false}
                            onClickAction={onCancel}
                        ></Button>
                    </div>
                </div>
            </div>
        </FormModal>
    );
};

export default ModalDecision;
